import { render, staticRenderFns } from "./BesoinSanteActifs.vue?vue&type=template&id=bb97f086&scoped=true&"
import script from "./BesoinSanteActifs.vue?vue&type=script&lang=js&"
export * from "./BesoinSanteActifs.vue?vue&type=script&lang=js&"
import style0 from "./BesoinSanteActifs.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BesoinSanteActifs.vue?vue&type=style&index=1&id=bb97f086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb97f086",
  null
  
)

export default component.exports